angular.module('rjmNg.services').factory "overdueBillingModalService", [
  "$modal"
  "app"
  "Billing"
  "Clients"
  (
    $modal
    app
    Billing
    Clients
  ) ->

    overdueBillingModalService = {}

    checkIfOverdue = ($scope, {id}) ->
      dateFormat = "MM/DD/YYYY"
      Billing.getStatus(id)
      .then ({isDelinquent, DeliquentInvoices, cached_payment}) =>
        if isDelinquent isnt "true" and not DeliquentInvoices?.length
          return

        # don't show modal when client recently entered a cc
        if cached_payment?
          return

        # sort the delinquent invoices asc by duedate
        overdueInvoicesAsc = _.sortBy DeliquentInvoices, (invoice) ->
          moment(invoice.duedate, dateFormat).unix()

        # get the oldest overdue invoice (it should be the first one since we sorted it asc)
        overdueInvoice = overdueInvoicesAsc[0]
        if moment(overdueInvoice.duedate, dateFormat).diff(moment(),'days') < -15
          overdueBillingModalService.showBillingModal($scope, false) #non-dismissable modal
        else if moment(overdueInvoice.duedate, dateFormat).diff(moment(),'days') < -5
          overdueBillingModalService.showBillingModal($scope, true) #dismissable modal

    checkIfClientWithSubscriptionIsOverdue = ($scope, {id}) ->
      Billing.getSubscriptionStatus(id)
      .then ({days_overdue, is_overdue}) =>

        if not is_overdue
          return

        if days_overdue > 15
          overdueBillingModalService.showBillingModal($scope, false, true) #non-dismissable modal
        else if days_overdue > 5
          overdueBillingModalService.showBillingModal($scope, true, true) #dismissable modal

    overdueBillingModalService.showBillingModal = ($scope, dismissable, hasMagentoSubscription = false) ->
      $modalScope = $scope.$new()
      $modalScope.allowModalDismiss = dismissable
      $modalScope.hasMagentoSubscription = hasMagentoSubscription
      modal = $modal
        template: 'modal.overdueBilling.html'
        show: true
        backdrop: 'static'
        scope: $modalScope
        keyboard: false
        priority: 5

    overdueBillingModalService.showModalIfOverdue = ($scope) ->
      # First check to see if the overdue modal is enabled for this client
      if not app.isOverdueModalEnabled()
        return

      Clients.get(app.getClientId())
      .then (clientInfo) ->
        if clientInfo?.properties?.magento_subscription_id? and
          clientInfo?.properties?.magento_subscription_id isnt ""
            checkIfClientWithSubscriptionIsOverdue($scope, clientInfo)
        else
          checkIfOverdue($scope, clientInfo)

    overdueBillingModalService
]
